// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3vJIF","inner":"Footer_inner__NsoN2","nextIcon":"Footer_nextIcon__KJvUm","innerLeft":"Footer_innerLeft__220-a"};